// extracted by mini-css-extract-plugin
module.exports = {"animation":"Expression_animation__1JcaP"};